module.exports = __webpack_public_path__ + "img/cadastro-checklist2.615a4008.jpg";